import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal, Tooltip, OverlayTrigger, Accordion, Card } from 'react-bootstrap'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";
import MultiCarouselPage from './MultiCarouselPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import $ from 'jquery'
import { useParams } from 'react-router-dom';

    
const ReportSelfDevelopment = props => {
    const { roomId, sId } = useParams();
    const [name, setName] = useState('');
    const [headline, setHeadline] = useState('แนวทางการพัฒนาตัวเอง');
    const [description, setDescription] = useState('หลายเรื่องราวที่ผ่านเข้ามาในชีวิตของเรามันทำให้เรามองเห็นอุปนิสัยเชิงบวกข้อไหนบ้าง?');  
    const [question, setQuestion] = useState('อุปนิสัยเชิงบวกในตัวของคุณ');     
    const [questionTextBox, setQuestionTextBox] = useState('เหตุการณ์ที่ทำให้คุณครูมองเห็นอุปนิสัยเชิงบวกของเรา');    
    const [data1, setData1] = useState([]);
    const [testSelf, setTextSelf] = useState([]);
    const [strengths, setStrengths] = useState([]);

    const [showFriendMode, setShowFriendMode] = useState('');
    const [showNotFriendMode, setShowNotFriendMode] = useState('');
    
    const [text1, setText1] = useState([]);
    const [accessDenied, setAccessDenied] = useState(false);
 
    const [currentSelect, setCurrentSelect] = useState('');
    const [studentId, setStudentId] = useState('');
    const responsive3 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            // partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }
    const responsive2 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }


    useEffect(() => {
        let student = '';
        let firstCard = '';
        if (sId) {
            student = sId
        } else if (AuthService.getUserRole() === 'student') {
            student = AuthService.getCurrentUserId();
        } else if (props && props.currentStudentId) {
            student = props.currentStudentId;
        }
        setStudentId(student);
        let doneStatus = false;
        let newStrengths = []
        UserService.getUserById(student).then((response) => {
            if (response.data && response.data.data && (response.data.data.id === student)) {
                setAccessDenied(true)
                UserService.getStrengths().then((response) => {
                    setStrengths(response.data.data)
                    console.log(response.data.data);
                    for (const [index, str] of response.data.data.entries()) { 
                        newStrengths[str.id] = {
                            image: str.imageUrl,
                            name: str.name,
                            description: str.description,
                            suggestion: str.suggestion
                        }
                    }
                    // setReStrengths(newStrengths)
                    return response.data.data
                }).then((apiStrengths) => {
                    UserService.getFriendShipList(student, {roomId}).then(        
                        (res) => {            
                    
                        var images0 = [];               
                        var stringHtml;     
                        var allAnswer0 = [];       
                        var allAnswer1 = [];               
                        var selfText = '';
                        var key = '';
                        var isTarget = true;
                    
        
                            setShowNotFriendMode('d-none');
                            setShowFriendMode('');
                            setTextSelf('');
                            var calIndex = 0;  
                            for (const [index, aAnswer] of res.data.data[0].others.entries()) { 
                                // console.log(aAnswer);    
            
                                if(aAnswer.user.roles[0].toLowerCase() !==  'teacher' && aAnswer.answerAt !== null && props.studentId !== aAnswer.user.id){            
            
                                    if(allAnswer0[aAnswer.answers[0].values[0]] === undefined){
                                        allAnswer0[aAnswer.answers[0].values[0]] = 1;
                                    } else {
                                        allAnswer0[aAnswer.answers[0].values[0]]++
                                    }
                                
                                    if(allAnswer0[aAnswer.answers[1].values[0]] === undefined){
                                        allAnswer0[aAnswer.answers[1].values[0]] = 1;
                                    } else {
                                        allAnswer0[aAnswer.answers[1].values[0]]++
                                    }
            
            
                                    if(allAnswer0[aAnswer.answers[2].values[0]] === undefined){
                                        allAnswer0[aAnswer.answers[2].values[0]] = 1;
                                    } else {
                                        allAnswer0[aAnswer.answers[2].values[0]]++
                                    }
                            
                            
                                    if(props.studentId !== aAnswer.user.id){
                                        allAnswer1[calIndex] = {
                                            'code': calIndex,
                                            'text': aAnswer.answers[3].values[0]
                                        }  
                                        calIndex++;
                                    }
                                
                                }
                            }   
        
                            var myArr0 = Object.fromEntries(
                                Object.entries(allAnswer0).sort(([, a], [, b]) => b - a)
                            );
                            

                            Object.keys(myArr0).map((aArray, i) => {
                                if(i === 0){
                                    firstCard = aArray;
                                    setCurrentSelect(aArray);
                                }
                                // tempPercent = res.data.data.percentages[aArray]
                                // stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer0[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                                if(allAnswer0[aArray] <= 1 ){
                                    stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                                } else {
                                    stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer0[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
            
                                }
                                console.log(aArray)
                                var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i0-${i}" onClick={() => { cardClick(aArray, '.tab0', newStrengths[aArray], '.i0'+aArray ) }}/>
                                images0.push(temp);
                            })    
                            console.log(myArr0)
            
                            const itemsText = [];          
                            
                            for (const [index, value] of  allAnswer1.entries()) {    
                                var temp = `<div class="border-radius-12 div-ans p-3" data-value="1"><div class="item text-left">${value.text}</div></div>`;
                                temp = <div dangerouslySetInnerHTML={{ __html: temp }} class="anywhere-wrap" key="t-${index}" />
                                itemsText.push(temp);               
                            }
                            setText1(itemsText);       
                        
                        
                        return [images0, itemsText];
        
                    }).then((res) => {
                        // console.log('res');
                        // console.log(res);
                        setData1(res[0]);   
                        setText1(res[1]);                           
                    }).then((res) => {     
                        $('body').find('.i0'+firstCard).addClass( "border-card");   
                        let text = newStrengths[firstCard];
                        $('.tab0').html('<div class="w-100" align="center"><h3 class="primary-text font-sarabun-bold">' + text.name +'</h3><h6 class="font-sarabun">' + text.suggestion + '</h6></div>');         
                    })
                });
            }
        }).catch(error => {
            $(".no-access-text").removeClass("d-none");
        });
        
    }, [])
    
        return (
            <div>    
                { (accessDenied) ? (            
                <div >
                    <Row className="">
                        <Col xs={12} md={12}  className="w-100 text-center pt-4 ">
                            <h2 class="font-sarabun-bold primary-text " >{ headline }</h2>
                        </Col>   
                    </Row>
                        
                    <Row className="pt-0 pb-3 report-tab">
                        <Col className="main-evaluate-overview">                                       
                            <Row className="py-3 bg-white mx-0">
                                <Col className="px-0">
                                    <MultiCarouselPage data={data1} responsive={data1.length > 3 ? responsive2 : responsive3} />                          
                                </Col>
                            </Row>
                            <Row className="py-3 bg-white mx-0 tab0 tab w-100">
                            </Row>        
                        </Col>
                    </Row>      

                    <Row>                
                        <Col className="main-evaluate-overview pb-3">                        
                            <Row>          
                                <Col xs={12} md={12} className="w-100 text-center pb-3">
                                    <a href={`/report/pdfdevelopself/${roomId}/${currentSelect}/${studentId}`} target="_blank"><Button className="bluesky d-inline py-1 py-md-2 px-4 font-sarabun-bold btn btn-primary export-btn m-auto"><h5 className="mb-0 font-weight-bold">Export</h5></Button></a>
                                </Col>          
                            </Row>
                        </Col>                   
                    </Row>                

                </div>
                ) : (
                <div align="center">
                    <h1 className="red-text mt-5 no-access-text d-none">Access Denied</h1>
                </div>
                ) }
            </div>
        )

        
        function cardClick(key, tab, str, ele){          
            setCurrentSelect(key);
            $('.tab').html('');               

            // if($('body').find(ele).hasClass( "border-card")){              
            $('body').find('.cardimage').removeClass( "border-card");
            // }
            $('body').find(ele).addClass( "border-card");
   
            $(tab).html('<div class="w-100" align="center"><h3 class="primary-text font-sarabun-bold">' + str.name +'</h3><h6 class="font-sarabun">' + str.suggestion + '</h6></div>');
           
        }
}

export default ReportSelfDevelopment